import noShowTableHTML from './noShowTableComponent.html';

export default {
  bindings: {
    data: '<',
    columns: '<',
    schema: '<',
    type: '<',
    sortMethod: '=?orderBy',
    canDataColumnBeVisible: '<',
    showDurationsAsDecimals: '<',
    filtersOpened: '<',
    statsOpened: '<',
    totalsModeEnabled: '<',
    getDataForExport: '=?',
    toggleCollapse: '=',
    collapsedGroups: '=',
  },
  controllerAs: 'ctrl',
  controllerProvider: async () =>
    (await import(/* webpackChunkName: "reports" */ './noShowTableComponentCtrl')).default,
  templateUrl: noShowTableHTML,
};
